import { api } from './client.js';

const root = '/me/passkeys';

export const passkeysApi = {
  list: () => api.get(root),
  registrationOptions: () => api.post(`${root}/registration/options`),
  registrationVerify: (body) => api.post(`${root}/registration/verify`, body),
  remove: (id) => api.delete(`${root}/${id}`),
  stepupOptions: () => api.post(`${root}/stepup/options`),
  stepupVerify: (response) => api.post(`${root}/stepup/verify`, { response }),
  loginOptions: (body) => api.post('/auth/login/passkey/options', body)
};
